export default function Footer() {
  const groups = [
    { title: "看脉络", links: [["核心时间线", "#timeline"], ["最新更新流", "#update"], ["当事人回应", "#response"]] },
    { title: "查资料", links: [["话题墙", "#topics"], ["归档资源", "#archive"], ["网友讨论", "#discuss"]] },
  ];

  return (
    <footer className="border-t border-background-300 bg-background-200/60">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-primary-700">抖音黑料</span>
                <span className="mt-1 text-[10px] font-medium tracking-widest text-foreground-400">时间线 · 全记录档案库</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              把抖音黑料的抖音黑料始末与前因后果，按抖音黑料时间线逐节点整理，发展经过与关键节点都在线可查，省得自己翻聊天记录和评论区拼瓜。
            </p>
          </div>

          {groups.map((g) => (
            <div key={g.title} className="md:col-span-2">
              <h4 className="text-sm font-bold text-foreground-900">{g.title}</h4>
              <ul className="mt-3 space-y-2">
                {g.links.map(([label, href]) => (
                  <li key={label}>
                    <a href={href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-900">保持更新</h4>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              归档仍在持续维护，新节点与当事人回应会第一时间并入主线。
            </p>
            <a
              href="#top"
              className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 whitespace-nowrap ring-1 ring-background-300 hover:text-primary-700"
            >
              <i className="ri-refresh-line text-primary-500" /> 回到顶部
            </a>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-background-300 bg-background-100/60 p-4 text-xs leading-relaxed text-foreground-500">
          <span className="mb-1 flex items-center gap-1.5 font-bold text-foreground-700">
            <i className="ri-error-warning-line" /> 内容声明
          </span>
          本站仅对网络上公开流传的讨论素材做「顺序与结构」层面的整理归档，用于帮助浏览者快速把握脉络；本页不生产、不坐实、不代表当事人或任何一方观点。
          涉及具体信息请以官方通报与当事人原始表述为准，并自行交叉核实。若素材涉及您的权益，请联系维护方作下架处理。
        </div>

        <div className="mt-6 flex flex-col gap-2 border-t border-background-300 pt-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 抖音黑料 时间线档案库 · 仅供信息整理参考</span>
          <span className="flex items-center gap-1.5">
            <i className="ri-archive-line text-accent-600" /> 网页由本地程序生成并托管
          </span>
        </div>
      </div>
    </footer>
  );
}